<template>
  <v-btn
      :id="id"
      v-if="!tooltip"
      :class="['m-button', colorTextClass,
      purple ? 'm-button--purple': outlined ? 'm-button--outlined': 'm-button--grey' ]"
      :icon="iconOnly"
      :disabled="disabled"
      :loading="loading"
      :small="small"
      :x-small="xSmall"
      :height="height"
      v-on="$listeners"
      class="m-button"
      elevation="0"
  >
    <span
        v-if="iconOnly"
        class="m-button__icon-box"
    >
      <v-icon class="m-button__icon-only" v-if="icon">
        {{ icon }}
      </v-icon>
      <slot name="icon" v-else/>
    </span>
    <span
        v-else
        class="m-button__text"
    >
        <v-icon
            v-if="icon"
            class="ml-3 custom-icon mr-2"
        >
        {{ icon }}
        </v-icon>
      <slot name="icon" v-else/>
      <span v-if="text">{{ text }}</span>
      <slot name="text" v-else/>
    </span>
  </v-btn>
  <v-tooltip
      v-else
      open-delay="300"
      top
  >
    <template #activator="{ on, attrs }">
      <!--          :color="colorBtn"-->
      <v-btn
          :class="colorTextClass"
          :icon="iconOnly"
          :outlined="outlined"
          :disabled="disabled"
          :small="small"
          :x-small="xSmall"
          v-bind="attrs"
          v-on="Object.assign({}, on, $listeners)"
      >
        <div v-if="iconOnly">
          <v-icon large>
            {{ icon }}
          </v-icon>
        </div>
        <div v-else>
          <span v-if="text">{{ text }}</span>
          <slot name="text" v-else/>
          <v-icon class="ml-3">
            {{ icon }}
          </v-icon>
        </div>
      </v-btn>
    </template>
    <span class="button__tooltip">
      {{ tooltip }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'm-button',
  props: {
    purple: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
    // iconSize: {
    //   type: String,
    //   default: 'large'
    // },
    color: {
      type: String,
      default: '', // 'red'
    },
    small: {
      type: Boolean,
      default: false,
    },
    xSmall: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 38
    }
  },
  computed: {
    colorTextClass() {
      return this.outlined ? `${this.color}--text` : (this.iconOnly ? '' : 'white--text')
    },
  },
}
</script>

<style lang="scss">

.button__tooltip {
  max-width: 250px;
  display: flex;
  flex-wrap: wrap;
}

.m-button {
  display: flex;
  //justify-content: start;
  justify-content: center;
  padding: 0 12px !important;
  border-radius: 6px;

  &__text {
    display: flex;
    align-items: center;
    font-family: Open Sans, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 0;
    text-transform: none !important;
    color: var(--dark-grey);
  }
}

.m-button--grey {
  background-color: #F8F8FB !important;
}

.m-button--grey .m-button__text {
  color: var(--dark-grey);
}

.m-button--purple {
  background-color: #8486D3 !important;
  display: flex;
  justify-content: center;
  padding: 12px !important;
  border-radius: 6px;
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: #C0C2FF !important;
  }
}

.m-button--purple .m-button__text {
  font-family: Open Sans, sans-serif;
  font-weight: 700;
  font-size: 11px;
  line-height: 130%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  color: white !important;
}


.custom-icon {
  width: 14px;
  height: 14px;
}

.m-button__icon-only {
  height: 24px;
  width: 24px;
}

.m-button__icon-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.m-button--outlined{
  border: 1px solid var(--another-grey);
  background-color: white !important;

  &:hover {
    background-color: #F8F8FB !important;
  };
}

.m-button--outlined .m-button__text {
  font-family: Open Sans, sans-serif;
  font-weight: 700;
  font-size: 16px !important;
  line-height: 140%;
  letter-spacing: 0;
  text-align: center;
  color: #78818B !important;
  padding-left: 10px;
  padding-right: 10px;
  margin: auto;
}
</style>

<style lang="scss">
.m-button--purple.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #A6ADB5 !important;
}

.m-button--outlined.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #F8F8FB !important;
}

.m-button.go-back-btn.v-btn.v-btn--disabled .v-btn__content .m-button__text span {
  color: #C7CBCF !important; /* Желаемый цвет текста */
}

.v-application--is-ltr .v-card__actions > .v-btn.v-btn + .v-btn{
  margin-left: 0 !important;
}

</style>